import jQuery from 'jquery';

const labelPrev = 'Poprzedni slajd';
const labelNext = 'Następny slajd';

export function mainSlider() {
    const element = jQuery('.main-slider');
    const timeout = jQuery(element).data('timeout') || 4000;
    jQuery(() => {
        jQuery(element)
            .slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                draggable: false,
                autoplay: true,
                autoplaySpeed: timeout,
            });
    });
}

export function latestEvents() {
    const element = jQuery('.events-slider .events-boxes');
    jQuery(() => {

        jQuery(element).on('init', function(event, slick){

            jQuery(element).find('.slick-arrow').attr('aria-label', labelNext);
            jQuery(element).find('.slick-arrow.slick-prev').attr('aria-label', labelPrev);
        });


        jQuery(element)
            .slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                draggable: true,
                autoplay: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipeToSlide: true,
                arrows: true,
                nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
                prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',

                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            arrows: false,
                        },
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                        },
                    },
                ],
            });
    });
}

export function objects() {
    const pageparts = jQuery('.objects-pp');

    jQuery(pageparts).each(function() {
        const pagepart = jQuery(this);
        const elements = pagepart.find('.objects-slider');

        jQuery(elements).each(function() {
            const element = jQuery(this);



        element.find('.object-overlay').find('.slick-arrow').attr('aria-label', labelNext);
        element.find('.object-overlay').find('.slick-arrow.slick-prev').attr('aria-label', labelPrev);

        element
            .slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                draggable: true,
                autoplay: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipeToSlide: true,
                arrows: true,
                fade: true,
                nextArrow: pagepart.find('.slick-next'),
                prevArrow: pagepart.find('.slick-prev'),

                responsive: [
                    {
                        breakpoint: 1160,
                        settings: {
                            arrows: false,
                        },
                    },
                ],
            });
        });
    });
}

export function projects() {
    const element = jQuery('.projects-slider');
    jQuery(() => {


            jQuery('.project-overlay').find('.slick-arrow').attr('aria-label', labelNext);
            jQuery('.project-overlay').find('.slick-arrow.slick-prev').attr('aria-label', labelPrev);


        jQuery(element)
            .slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                draggable: true,
                autoplay: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true,
                swipeToSlide: true,
                arrows: true,
                fade: true,
                nextArrow: jQuery('.projects-pp .slick-next'),
                prevArrow: jQuery('.projects-pp .slick-prev'),

                responsive: [
                    {
                        breakpoint: 1160,
                        settings: {
                            arrows: false,
                        },
                    },
                ],

            });
    });
}

export function days(currentDay = null) {
    const element = jQuery('.event-calendar__days .content .event-calendar-days-content');

    jQuery(() => {

            jQuery('.event-calendar__days').find('.slick-arrow').attr('aria-label', labelNext);
            jQuery('.event-calendar__days').find('.slick-arrow.slick-prev').attr('aria-label', labelPrev);


        jQuery(element)
            .slick({
                infinite: false,
                slidesToShow: 10,
                slidesToScroll: 3,
                dots: false,
                draggable: true,
                autoplay: false,
                adaptiveHeight: true,
                swipeToSlide: true,
                arrows: true,
                nextArrow: jQuery(element).parent().find('.slick-next'),
                prevArrow: jQuery(element).parent().find('.slick-prev'),
                initialSlide: (currentDay) ? currentDay - 1 : 0,

                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 7,
                        },
                    },
                ],
            });
    });
}
